import { usePermissionStore } from '@/stores/PermissionStore';
import { useSessionStore } from '@/stores/SessionStore';
import { useTenantStore } from '@/stores/TenantStore';

/**
 * Facade over the auth/permission/tenant stores. Preserves the original `useAuth` surface so
 * route guards, `<Can>`, the layout, and feature hooks consume one cohesive object.
 */
export function useAuth() {
  const session = useSessionStore();
  const permissions = usePermissionStore();
  const tenant = useTenantStore();

  return {
    // session
    profile: session.profile,
    isAuthenticated: session.isAuthenticated,
    initializing: session.initializing,
    /** Why the last session ended ('logout' elsewhere, 'expired'), or null. */
    endReason: session.endReason,
    login: session.login,
    adopt: session.adopt,
    logout: session.logout,
    // permissions
    hasPermission: permissions.hasPermission,
    hasAnyPermission: permissions.hasAnyPermission,
    hasAllPermissions: permissions.hasAllPermissions,
    // tenant
    tenantCode: tenant.tenantCode,
  };
}
